import React from 'react';
import './Footer.scss';

const Footer = () => (
  <div className="main-footer">
    <strong>Copyright</strong> 비주얼 © 2017-2022
  </div>
);

export default Footer;
